import {
  categoryToLabel,
  categoryToIcon,
} from "@/v2/components/formatters/CategoryFormatter";
import {
  getStatusIcon,
  formatString as getStatusText,
} from "@/v2/components/formatters/StatusFormatter";
import {
  formatString as getChannelText,
  channelToIcon,
} from "@/v2/components/formatters/ChannelFormatter";
import { ExploreColumnType } from "../columns/ExploreColum.model";
import {
  getResolutionStatusIcon,
  getResolutionStatusText,
} from "./ResolutionStatusFormatter";
import { getEscalationReasonText } from "./EscalationReasonFormatter";
import { getSkipReasonText } from "./SkipReasonFormatter";
import { getResolvedReasonText } from "./ResolvedReasonFormatter";
import { getOriginAuthorText } from "./OriginAuthorFormatter";

type Formatter = {
  getText: (value: string) => string;
  getIcon?: (value: string) => React.ReactNode;
};

export const exploreColumnTypeFormatters: Record<
  ExploreColumnType,
  Formatter | null
> = {
  tenantId: null,
  id: null,
  displayId: null,
  subject: null,
  description: null,
  createdAt: null,
  updatedAt: null,
  status: {
    getText: (value) => getStatusText(value),
    getIcon: (value) => getStatusIcon(value),
  },
  channel: {
    getText: (value) => getChannelText(value),
    getIcon: (value) => channelToIcon[value],
  },
  topic: null,
  subTopic: null,
  category: {
    getText: (value) => categoryToLabel[value],
    getIcon: (value) => categoryToIcon[value],
  },
  agentAssigned: null,
  team: null,
  teams: null,
  tenantUser: null,
  tenantOrganization: null,
  tags: null,
  avgQaScore: null,
  avgQaScoreRoundRange: null,
  avgQuackMessageScoreRoundRange: null,
  avgAutoQaScore: null,
  avgSentiment: null,
  lastSentiment: null,
  avgQuackMessageScore: null,
  csat: null,
  csatComment: null,
  countPublicMessages: null,
  countInternalMessages: null,
  timeToResolution: null,
  timeToFirstResponse: null,
  resolutionStatus: {
    getText: getResolutionStatusText,
    getIcon: getResolutionStatusIcon,
  },
  escalationReason: {
    getText: getEscalationReasonText,
  },
  skipReason: {
    getText: getSkipReasonText,
  },
  resolvedReason: {
    getText: getResolvedReasonText,
  },
  countQuackMessages: null,
  isQuackEscalated: null,
  isQuackAnswered: null,
  isAnsweredByAui: null,
  collaborators: null,
  isFiniteState: null,
  validationStatus: null,
  agentAssignedId: null,
  ticketId: null,
  originAuthor: {
    getText: getOriginAuthorText,
  },
  originUrl: null,
  scoreTitle: null,
  scoreContent: null,
  simulatorId: null,
  skillUsed: null,
  skillsUsed: null,
  isUserAuthenticated: null,
  avgCsat: null,
};
